<template>
  <div>
    <article class="resort-item resort-item-large yacht-result-item">
      <div class="yacht-slider">
        <cabin-image-carousel :images="images" />
      </div>

      <a :href="yacht.__platform_url" target="_blank">
        <h4 class="fs-20 font-medium">
          <span v-html="yacht.__platform_name" />
          <svg class="top-pick-icon" v-if="yacht.__odyssey_zublu_featured">
            <use xlink:href="/img/sprite.svg#ic_shield-tick--solid" />
          </svg>
        </h4>

        <div class="flex items-center text-black-light-5 fs-14 mt-1">
          <p v-html="cabinDescriptions"></p>
          <ul class="list-reset flex items-center flex-wrap">
            <li class="flex-none">
              <span class="mx-1">•</span>
            </li>

            <li class="flex-none">
              {{ yacht.__odyssey_vessel_length }}m
              <span class="mr-1">•</span>
            </li>

            <li class="flex-none">
              {{ crewDisplay }}
            </li>
          </ul>
        </div>

        <p class="mt-4">
          {{ yacht.__platform_description }}
        </p>
      </a>
    </article>

    <a :href="yacht.__platform_url" target="_blank">
      <ul class="list-reset trip-list mt-4 fs-14">
        <li
          v-for="itinerary in yacht.__odyssey_itineraries"
          :key="itinerary.id"
          class="itinerary-grid"
        >
          <div class="flex items-center w-2/3 pr-6">
            <svg width="24" height="24" class="inline-block mr-1 flex-shrink-0">
              <use xlink:href="/img/sprite.svg#ic_itinerary"></use>
            </svg>
            <span class="font-medium truncate">
              {{ itinerary.charter_itinerary.name }}
            </span>
            <span class="px-4">|</span>
            <span class="truncate">{{
              itinerary.charter_itinerary.itinerary_destination_text
            }}</span>
          </div>

          <div class="flex items-center justify-between w-1/3 py-1 lh-150">
            <div>
              <svg width="24" height="24" class="inline-block">
                <use xlink:href="/img/sprite.svg#ic_calendar"></use>
              </svg>
              {{ getItinerarySeasonsDisplay(itinerary) }}
            </div>
            <div>
              <span class="font-medium">
                <currency-context>
                  <template v-slot="{ convert }">
                    <span
                      v-text="convert(itinerary.price_per_night)"
                    ></span>
                  </template>
                </currency-context>
              </span>
              /night
            </div>
          </div>
        </li>
      </ul>
    </a>
  </div>
</template>

<script>
import isEmpty from "lodash/isEmpty";
import uniq from "lodash/uniq";
import CabinImageCarousel from "./../../views/liveaboard/CabinImageCarousel";
import YachtItemMixin from "../../mixins/YachtItemMixin";
import SeasonMixin from "../../views/yacht/SeasonMixin";
import CurrencyContext from "../core/CurrencyContext";

export default {
  mixins: [YachtItemMixin, SeasonMixin],
  components: {
    CabinImageCarousel,
    CurrencyContext
  },
  props: ["yacht"],
  computed: {
    images() {
      return uniq(this.yacht.__platform_gallery);
    },
  },
  methods: {
    getItinerarySeasonsDisplay(itinerary) {
      const out = this.convert(this.monthNumbers(itinerary), "MMM", "-");
      return isEmpty(out) ? "Year round" : out;
    },
    monthNumbers(itinerary) {
      try {
        let seasons = JSON.parse(itinerary.season);
        return seasons
          .map((monthName) =>
            Number(
              moment()
                .month(monthName)
                .format("M")
            )
          )
          .sort((a, b) => a - b);
      } catch (error) {
        return [];
      }
    },
  },
};
</script>

<style scoped>
.itinerary-grid {
  display: flex;
  line-height: 48px;
  padding-left: 24px;
  padding-right: 24px;
  border-bottom: 1px solid var(--black-light-2);
  border-right: 1px solid var(--black-light-2);
  border-left: 1px solid var(--black-light-2);
}

.itinerary-grid:nth-child(2n + 1) {
  background-color: var(--black-light-1);
}

.itinerary-grid:last-child {
  border-bottom: 1px solid var(--black-light-2);
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.itinerary-grid:first-child {
  border-top: 1px solid var(--black-light-2);
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
</style>
